import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useRef, useState } from 'react';
/**
 * The framed Computer command menu grows the composer frame downward. Holding the slot at its
 * closed height and floating the composer lets the menu cover the toolbar and list below
 * instead of pushing them down.
 */
function FloatWhileOpen({ open, children }) {
    const contentRef = useRef(null);
    const [closedHeight, setClosedHeight] = useState();
    useLayoutEffect(() => {
        const content = contentRef.current;
        if (open || content === null)
            return;
        const measure = () => setClosedHeight(content.offsetHeight);
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(content);
        return () => observer.disconnect();
    }, [open]);
    const floating = open && closedHeight !== undefined;
    return (_jsx("div", { className: "relative", style: floating ? { height: closedHeight } : undefined, children: _jsx("div", { ref: contentRef, className: floating ? 'absolute inset-x-0 top-0 z-30' : undefined, children: children }) }));
}
export { FloatWhileOpen };
//# sourceMappingURL=FloatWhileOpen.js.map